import { render, staticRenderFns } from "./NotaFiscalPrincipal.vue?vue&type=template&id=4355e463&"
import script from "./NotaFiscalPrincipal.vue?vue&type=script&lang=js&"
export * from "./NotaFiscalPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports